<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="Clases">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br /><br />

        <div
          class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary--text
          "
        >
          Secretaria Virtual
        </div>
      </v-col>

      <v-row no-gutters v-if="horarios.length == 0">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert
              prominent
              type="info"
            >
             No hay Horarios disponibles en estos momentos
            </v-alert>
          </v-col>
        </v-row>

      <v-expansion-panels class="mb-12" v-else>
        <v-expansion-panel v-for="(item, index) in horarios" :key="index">
          <v-expansion-panel-header>
            <span class="font-weight-black"
              >Horario de atencion : {{ item.horaDesde }} hasta
              {{ item.horaHasta }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ item.notas }} <br /><br />
            <a :href="item.meet" class="text-decoration-underline font-italic"
              >ir al Meet</a
            >
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
  name: "Secretaria",
  components: {
    CardIeaAppMain,
  },
  data() {
    return {
      horarios: [],
    };
  },
  mounted() {
    this.listaHorarios();
  },

  methods: {
    listaHorarios() {
      this.$API
        .get({
          url: "secretaria",
        })
        .then((res) => {
          this.horarios = res;
        });
    },
  },
};
</script>